import { toProjectTechnicalReviewAcInput } from './projectTechnicalReviewAcInput';
import { toProjectTechnicalReviewDcInput } from './projectTechnicalReviewDcInput';
import {
  TECHNICAL_REVIEW_AC_REQUIRED_FIELDS,
  TECHNICAL_REVIEW_DC_REQUIRED_FIELDS,
} from './technicalReviewCompleteness';

/**
 * The sides of the technical review, each one block of the tab Techn. Prüfung (see feature page
 * projekt-technische-pruefung). `ProjectTechnicalReviewSide` renders a side from its entry:
 * - `stateField`: "geprüft" (Ja/Nein), first row left
 * - `durationField`: planned duration in seconds, first row right
 * - `richTextFields`: full-width rich text fields below, in this order
 * - `requiredFields`: fields that must be filled for "geprüft = Ja"
 * - `labelKey`: block label, `saveAction`: store action, `toInput`: mutation input
 */
export const TECHNICAL_REVIEW_SIDES = {
  dc: {
    stateField: 'dcInspectedState',
    durationField: 'expectedDcTimeExpenditureInSeconds',
    richTextFields: ['dcNotes', 'dcInstallationTeamNotes'],
    requiredFields: TECHNICAL_REVIEW_DC_REQUIRED_FIELDS,
    labelKey: 'project_technical_review_dc',
    saveAction: 'updateProjectTechnicalReviewDc',
    toInput: toProjectTechnicalReviewDcInput,
  },
  ac: {
    stateField: 'acInspectedState',
    durationField: 'expectedAcTimeExpenditureInSeconds',
    richTextFields: ['acNotes', 'installationTeamNotes'],
    requiredFields: TECHNICAL_REVIEW_AC_REQUIRED_FIELDS,
    labelKey: 'project_technical_review_ac',
    saveAction: 'updateProjectTechnicalReviewAc',
    toInput: toProjectTechnicalReviewAcInput,
  },
};
